import React, { useEffect } from 'react';
import './ceresos.css';
import { ceresos } from '../../json/ceresos';


const Ceresos = () => {
   
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

      


  return (
    <div className='container transparencia-container'>
        <div className='row'>
            <div className='col_12'>
                <div className='transparencia_title'>
            
                    <h3 className='title-silver'>Directorio de CERESOs</h3>
                    <hr className='hr-gob'/>
                </div>
            </div>
        </div>
        <div className='row'>
            
            <div className='row'>
            {
                ceresos.map((item, index)=>(
                    
                    <div key={ index } className='col-lg-4 col-sm-12  ceresos_item'>
                        <article>
                            <h3>{ item.municipio }</h3>
                            <p>{ item.direccion }
                            <br/><a href={"tel:"+ item.telefonolink }> Teléfono: { item.telefono }</a></p>
                        </article>
                    </div>
                    
                ))
            }
        </div>
        </div>
    </div>
  )
}

export default Ceresos